<template>
  <ul class="nav nav-mobile-menu">
    <!-- <base-dropdown>
      <template slot="title">
        <i class="fa fa-globe"></i>
        <b class="caret"></b>
        <span class="notification">5 Notifications</span>
      </template>
      <a class="dropdown-item" href="#">Notification 1</a>
      <a class="dropdown-item" href="#">Notification 2</a>
      <a class="dropdown-item" href="#">Notification 3</a>
      <a class="dropdown-item" href="#">Notification 4</a>
      <a class="dropdown-item" href="#">Another notification</a>
    </base-dropdown> -->
    <!-- <base-dropdown title="Dropdown">
      <a class="dropdown-item" href="#">Action</a>
      <a class="dropdown-item" href="#">Another action</a>
      <a class="dropdown-item" href="#">Something</a>
      <a class="dropdown-item" href="#">Something else here</a>
      <div class="divider"></div>
      <a class="dropdown-item" href="#">Separated link</a>
    </base-dropdown> -->

    <sidebar-link to="/me/profile">
      <i class="nc-icon nc-single-02 hidden-lg-up"></i>
      <p>Profile</p>
    </sidebar-link>
    <li class="nav-item">
      <a class="nav-link" @click.prevent="checkUpdate" href="#">
        <i class="nc-icon nc-layers-3 hidden-lg-up"></i>
        <span class="d-lg-none">Check for Update</span>
      </a>
    </li>
    <li v-if="hasEmulation" class="nav-item">
      <a class="nav-link" @click.prevent="authRelease" href="#">
        <i class="nc-icon nc-button-power hidden-lg-up"></i>
        <span class="d-lg-none">End Emulation</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" @click.prevent="logout" href="#">
        <i class="nc-icon nc-button-power hidden-lg-up"></i>
        <span class="d-lg-none">Log out</span>
      </a>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'mobile-menu',
    computed: {
      hasEmulation () {
        let tokenPayload = this.$store.getters.tokenPayload()
        return 'eid' in tokenPayload
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('authLogout')
      },
      authRelease () {
        this.$store.dispatch('authEmulate', { action: 'release' })
      },
      checkUpdate () {
        location.reload(true)
      }
    }
  }
</script>
<style>
</style>
